import React from 'react';
import { X } from 'lucide-react';
import Login from './Login';
import Register from './Register';

export default function AuthModal({ isOpen, onClose, isLoginMode, setIsLoginMode }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 relative animate-slide-up">
        
        {/* Nút đóng modal */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-xl transition"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Tiêu đề modal */}
        <div className="text-center mb-5">
          <h2 className="text-2xl font-bold font-serif text-slate-900">
            {isLoginMode ? "Chào mừng trở lại!" : "Tạo tài khoản mới"}
          </h2>
          <p className="text-xs text-slate-500 mt-1">
            {isLoginMode ? "Đăng nhập để quản lý giỏ hàng và đơn hàng" : "Điền thông tin để tham gia cùng JapanICHIBA"}
          </p>
        </div>

        {/* Hiển thị Login hoặc Register */}
        {isLoginMode ? (
          <Login 
            onSuccess={(userData) => {
              // Khi đăng nhập thành công qua AuthContext, chỉ cần đóng modal
              onClose();
            }} 
          />
        ) : (
          <Register 
             onSuccess={(userData) => {
              // Khi đăng nhập thành công qua AuthContext, chỉ cần đóng modal
              onClose();
            }} 
          />
        )}

        {/* Chuyển đổi giữa Đăng nhập và Đăng ký */}
        <div className="mt-5 text-center text-xs text-slate-500">
          {isLoginMode ? (
            <p>
              Chưa có tài khoản?{' '}
              <button
                onClick={() => setIsLoginMode(false)}
                className="text-indigo-600 font-bold hover:underline"
              >
                Đăng ký ngay
              </button>
            </p>
          ) : (
            <p>
              Đã có tài khoản?{' '}
              <button
                onClick={() => setIsLoginMode(true)}
                className="text-indigo-600 font-bold hover:underline"
              >
                Đăng nhập
              </button>
            </p>
          )}
        </div>

      </div>
    </div>
  );
}